export interface Tnews {
    id?: number,
    uniqueId: string,
    createDate: string,
    name: string,
    slug: string,
    content: string,
    content_plain: string,
    thumbnail: string,
    author: string,
    headline: boolean,
    active: boolean,
}

export const initialNews: Tnews = {
    uniqueId: "",
    createDate: "",
    name: "",
    slug: "",
    content: "",
    content_plain: "",
    thumbnail: "",
    author: "",
    headline: false,
    active: false
}